export default __webpack_public_path__ + "static/media/andy.53c2fe89.jpeg";